import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './styles/main.css'
import App from './App.vue'

// Создаем приложение
const app = createApp(App)

// Подключаем Pinia для управления состоянием
app.use(createPinia())

// Подключаем Vue Router
app.use(router)

// Монтируем приложение
app.mount('#app')

console.log('🚀 Dashboard System запущен!')